import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { useGetQuery } from "../../../hooks/useClientPortalQuery";
import { CreditCardInfo } from "../../../types/generated/models";

interface ICustomFormClientCreditCardDetails {
    creditCardInfo?: CreditCardInfo | null;
    isLoading: boolean;
}

export function useCustomFormClientCreditCardDetails(
    publicId: string,
    practitionerId?: number
): ICustomFormClientCreditCardDetails {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const params = new URLSearchParams();
    params.append("publicId", publicId.toString());

    if (practitionerId) {
        params.append("practitionerId", practitionerId.toString());
    }

    const { data, isLoading = true } = useGetQuery<CreditCardInfo | null>({
        url: `/api/v1/${clientPortalGuid}/Stripe/GetCustomFormCreditCard?${params.toString()}`,
    });

    return { creditCardInfo: data, isLoading };
}
